import {CdkStep, CdkStepper, STEP_STATE, StepperOptions} from '@angular/cdk/stepper';

/**
 * Header-Symbole der Bestellstrecke: nicht angefasst = Ziffer, fertig = Haken, gerade in Bearbeitung = Stift.
 *
 * Die Standardlogik von Material zeigt für den geöffneten Schritt immer die Ziffer und für erledigte,
 * editierbare Schritte den Stift. Mit displayDefaultIndicatorType: false gilt stattdessen: erledigt und
 * nicht geöffnet = Haken, sonst der über [state] gesetzte Zustand - s. stepIndicatorState().
 */
export const ORDER_STEPPER_OPTIONS: StepperOptions = {displayDefaultIndicatorType: false};

/** Für [state] jedes Schritts: der geöffnete Schritt bekommt den Stift, alle anderen die Ziffer. */
export function stepIndicatorState(step: CdkStep, stepper: CdkStepper): string {
  return stepper?.selected === step ? STEP_STATE.EDIT : STEP_STATE.NUMBER;
}
